/**
 * Завершені статуси прототипу v4 (константа DONE; на сервері — Platform.Bl DoneStatuses і псевдополе фільтр-DSL `isDone`): за ними, а не за
 * прапорцем closed статусу модуля, прототип фарбує прострочений термін у таблиці й календарі та рахує «Відкрито» / «Прострочено» швидкого
 * фільтра («Зареєстровано» конструктора законопроєктів — не завершений, «Опубліковано» бази знань — завершений).
 */
export const DONE_STATUSES: readonly string[] = [
  'Resolved', 'Closed', 'Done', 'Adopted', 'Rejected', 'Answered', 'Held', 'Cancelled', 'Recorded', 'Repealed', 'Minutes approved', 'Published',
  'Concluded', 'Archived', 'Completed', 'Delivered', 'Posted', 'Debated', 'Accepted', 'Expired', 'Retired',
];

/** Чи статус завершений за правилом прототипу (DONE). Чиста функція. */
export function isDoneStatus(status: string | null | undefined): boolean {
  return Boolean(status) && DONE_STATUSES.includes(status as string);
}
